import React, { useState, useCallback, useEffect } from 'react';
import PropTypes from 'prop-types';
import { Button, Modal, Typography } from 'antd';
import * as api from './api';

/**
 * 协议选择主体
 * @param {array<number>} values 选中的协议值
 * @param {array<object>} agreements 协议列表
 * @param {function} onChange 选中回调
 */
const Sign = ({ value, agreements = [], onChange }) => {
  return (
    <div>
      您需要确认并认同&nbsp;&nbsp;
      {agreements.map(agreement => (
        <span key={agreement.id}>
          <Typography.Link href={agreement.p1} target="_blank">
            {agreement.title}
          </Typography.Link>
          ,
        </span>
      ))}
      {/* <Select
        mode="multiple"
        style={{ width: 200 }}
        placeholder="协议选择"
        value={value}
        onChange={onChange}
      >
        {agreements.map((agreement, index) => (
          <Select.Option
            key={index}
            value={agreement.id}
            label={agreement.title}
          >
            {agreement.title}
          </Select.Option>
        ))}
      </Select> */}
      &nbsp;&nbsp; 才能正式参与项目
    </div>
  );
};

Sign.propTypes = {
  value: PropTypes.arrayOf(PropTypes.number),
  agreements: PropTypes.arrayOf(PropTypes.object),
  onChange: PropTypes.func,
};

const DialogSign = ({ id, disabled, onChange }) => {
  const [dialog, setDialog] = useState(false);
  const [loading, setLoading] = useState(false);
  const [agreements, setAgreements] = useState([]);
  const [agreementIds, setAgreementIds] = useState([]);
  const handleQueryAgreement = useCallback(
    () =>
      api.queryWaitConfirmAgreement({ id }).then(res => {
        const data = res.data || [];
        setAgreementIds(data.map(item => item.id));
        setAgreements(data);
        if (data.length) setDialog(true);
      }),
    [id]
  );

  const handleCreateAgreement = useCallback(
    status => () => {
      setLoading(true);
      api
        .createAgreement({ id, agreementId: agreementIds, status })
        .then(() => {
          setDialog(false);
          onChange(status);
        })
        .finally(() => setLoading(false));
    },
    [agreementIds, id, onChange]
  );

  useEffect(() => {
    if (id && !disabled) handleQueryAgreement();
  }, [disabled, handleQueryAgreement, id]);
  return (
    <Modal
      title="协议确认"
      visible={dialog}
      onCancel={() => setDialog(false)}
      footer={[
        <Button
          key="10"
          loading={loading}
          disabled={disabled}
          onClick={handleCreateAgreement('10')}
        >
          不同意
        </Button>,
        <Button
          key="00"
          type="primary"
          loading={loading}
          disabled={disabled}
          onClick={handleCreateAgreement('00')}
        >
          同意
        </Button>,
      ]}
    >
      <Sign
        value={agreementIds}
        agreements={agreements}
        onChange={setAgreementIds}
      />
    </Modal>
  );
};

DialogSign.propTypes = {
  id: PropTypes.number,
  disabled: PropTypes.bool,
  onChange: PropTypes.func,
};

export default DialogSign;
